import { useState } from "react";
import { TimeRange, TIME_RANGE_OPTIONS } from "./timeRange";
import LinkedInDataTable from "./LinkedInDataTable";
import FollowerGrowthChart from "./FollowerGrowthChart";
import DemographicsBarChart from "./DemographicsBarChart";
import ContentMetricsChart from "./ContentMetricsChart";
import InteractionShareChart from "./InteractionShareChart";
import PostPerformanceChart from "./PostPerformanceChart";
import MarketingConceptEvaluation from "./MarketingConceptEvaluation";

export type ExtraVisualizationType =
  | "barChart"
  | "lineChart"
  | "multiLineChart"
  | "pie"
  | "postChart";

const extraVisualizationOptions: {
    id: ExtraVisualizationType;
    label: string;
}[] = [
    {
        id: "barChart",
        label: "Demografie",
    },
    {
        id: "lineChart",
        label: "Follower-Wachstum",
    },
    {
        id: "multiLineChart",
        label: "Content-Metriken",
    },
    {
        id: "pie",
        label: "Interaktionen",
    },
    {
        id: "postChart",
        label: "Post-Performance",
    },
];

interface DataVisualizerProps {
  refreshKey: number;
}

export default function DataVisualizer({refreshKey,}: DataVisualizerProps){
    const [selectedExtraVis, setSelectedExtraVis] = useState<ExtraVisualizationType>("barChart");
    const[timeRange, setTimeRange] = useState<TimeRange>("all");

    const accountOptions = ["gamedays-tu-darmstadt", "serious-games-group-tu-darmstadt"];


    return (
        <div className="analysis-dashboard">
            <section className="analysis-panel">
            <div className="analysis-panel-header">
                <div>
                <h2>Marketing Evaluation</h2>
                <p>Überblick über die wichtigsten Marketing-Kennzahlen.</p>
                </div>
            </div>

            <div className="analysis-panel-content">
                <MarketingConceptEvaluation
                timeRange={timeRange}
                />
            </div>
            </section>

            <section className="analysis-panel">
            <div className="analysis-panel-header">
                <div>
                <h2>Weitere Analysen</h2>
                <p>Wähle eine zusätzliche Visualisierung.</p>
                </div>

                <select
                value={timeRange}
                onChange={(e) =>
                    setTimeRange(e.target.value as TimeRange)
                }
                className="analysis-time-select"
                >
                {TIME_RANGE_OPTIONS.map((option) => (
                    <option key={option.id} value={option.id}>
                    {option.label}
                    </option>
                ))}
                </select>
            </div>

            <div className="analysis-switcher">
                {extraVisualizationOptions.map((option) => (
                <button
                    key={option.id}
                    type="button"
                    className={
                    selectedExtraVis === option.id
                        ? "analysis-switch active"
                        : "analysis-switch"
                    }
                    onClick={() => setSelectedExtraVis(option.id)}
                >
                    {option.label}
                </button>
                ))}
            </div>

            <div className="analysis-extra-content">
                {selectedExtraVis === "barChart" && (
                <DemographicsBarChart
                    refreshKey={refreshKey}
                    accountOptions={accountOptions}
                />
                )}

                {selectedExtraVis === "lineChart" && (
                <FollowerGrowthChart
                    refreshKey={refreshKey}
                    timeRange={timeRange}
                />
                )}

                {selectedExtraVis === "multiLineChart" && (
                <ContentMetricsChart
                    refreshKey={refreshKey}
                    accountOptions={accountOptions}
                    timeRange={timeRange}
                />
                )}

                {selectedExtraVis === "pie" && (
                <InteractionShareChart
                    refreshKey={refreshKey}
                    accountOptions={accountOptions}
                    timeRange={timeRange}
                />
                )}

                {selectedExtraVis === "postChart" && (
                <PostPerformanceChart
                    refreshKey={refreshKey}
                    accountOptions={accountOptions}
                    timeRange={timeRange}
                />
                )}
            </div>
            </section>
        </div>
        );
}